import type { Action } from "../actions/types";

/**
 * Holds the claim payment retry that waits for a decision on the open claim,
 * and the list of requests waiting for an approver.
 *
 * `retry` is null when no request is open for the claim. That is a normal
 * state, so the screen must tell it apart from "not loaded yet".
 */
export interface ClaimPaymentRetryState {
  retry: any | null;
  queue: any[];
  loaded: boolean;
}

const initialState: ClaimPaymentRetryState = {
  retry: null,
  queue: [],
  loaded: false,
};

const claimPaymentRetryReducer = (
  state: ClaimPaymentRetryState = initialState,
  action: Action
): ClaimPaymentRetryState => {
  switch (action.type) {
    case "SET_CLAIM_PAYMENT_RETRY":
      return { ...state, retry: action.data || null, loaded: true };
    case "SET_CLAIM_PAYMENT_RETRY_QUEUE":
      return { ...state, queue: action.data || [] };
    case "CLEAR_CLAIM_PAYMENT_RETRY":
      return initialState;
    default:
      return state;
  }
};

export default claimPaymentRetryReducer;
